export const SHOP = 'shop';
export const TREE = 'tree';
export const PREM = 'prem';
export const SHELF = 'shelf';
export const BOXES = 'boxes';
